import type { FC } from 'react';

import G from '@wwe-portal/ui/assets/images/store-revamp/star-gold.webp';
import B from '@wwe-portal/ui/assets/images/store-revamp/star-bronze.webp';
import S from '@wwe-portal/ui/assets/images/store-revamp/star-silver.webp';

const srcMap = {
  G,
  B,
  S,
};

export const SixStarIcon: FC<{
  size?: number;
  className?: string;
  variant: 'B' | 'S' | 'G';
}> = ({ size = 55, variant, className }) => {
  return (
    <img
      alt="Six Star Gold"
      height={size}
      src={srcMap[variant]}
      width={size}
      className={className}
    />
  );
};
